import { SemId } from '~/contracts/sem';

const defaultSemModularRequest: SemId = {
  input: { templateName: 'Open' },
  request: { filters: {} }
};

export default defaultSemModularRequest;
